import { CustomBoxV2 } from "components";
import { FullSwingIcon } from "pages/internal-dashboard/icons";

export function FullSwing({ data, loading, percentages }: any) {
  return (
    <CustomBoxV2
      loading={loading}
      color="#E1E3E8"
      title="Full Swing"
      userCount={data?.total || 0}
      boxData={{
        label: "Full Swing",

        todayCount: data?.day || 0,
        weekCount: data?.week || 0,
        monthCount: data?.month || 0,
        yearCount: data?.year || 0,
        icon: FullSwingIcon,
      }}
      percentages={percentages}
    />
  );
}
